<template>
  <OwnStack>
    <OwnStack
      v-for="item of items"
      :key="item[itemKey]"
      class="own-checkbox-group__row"
      :class="[
        disabledItems.includes(item[itemKey]) &&
          'own-checkbox-group__row--disabled',
      ]"
      align="center"
      justify="between"
      row
      el="label"
      :for="item[itemKey]"
    >
      <OwnStack el="span" spacing="2" align="center" row>
        <slot name="prefix" :item="item"></slot>

        <OwnType
          :text="item.label"
          el="span"
          variant="subtitle"
          :color="
            disabledItems.includes(item[itemKey]) ? 'secondary' : 'primary'
          "
        />
      </OwnStack>

      <input
        :id="item[itemKey]"
        v-model="selectedValues"
        :disabled="disabledItems.includes(item[itemKey])"
        :value="item[itemKey]"
        type="checkbox"
      />
    </OwnStack>
  </OwnStack>
</template>

<script>
import { OwnStack } from '../OwnStack'
import { OwnType } from '../OwnType'

export default {
  name: 'OwnCheckboxGroup',
  components: {
    OwnStack,
    OwnType,
  },
  props: {
    disabledItems: { type: Array, default: () => [] },
    /**
     * Item key to be used for for-key
     * @default id
     */
    itemKey: { type: [String], default: 'id' },

    /**
     * Items to render
     */
    items: { type: Array, default: () => [] },

    /**
     * Selected items
     * @model
     */
    value: { type: Array, default: () => [] },
  },
  computed: {
    selectedValues: {
      get() {
        return this.value
      },
      set(newValue) {
        this.$emit('input', newValue)
      },
    },
  },
}
</script>

<style lang="scss">
.own-checkbox-group {
  &__row {
    padding: 12px 0;
    border-bottom: 1px dashed $background-divider;
    user-select: none;
    cursor: pointer;

    &:first-child {
      padding: 0 0 12px 0;
    }

    &:last-child {
      padding: 12px 0 0 0;
      border-bottom: none;
    }

    &--disabled {
      cursor: not-allowed;
    }
  }
}
</style>
